import { AchooModalDialogInstanceService } from './achoo-modal-dialog-instance.service';
import { Optional, SkipSelf, ModuleWithProviders, InjectionToken, NgModule } from '@angular/core';
import { AchooModalDialogComponent } from './achoo-modal-dialog.component';
import { AchooSimpleModalComponent } from './achoo-simple-modal.component';
import { CommonModule } from '@angular/common';
import { ModalDialogService } from '../../services/modal-dialog/achoo-modal-dialog.service';

/**
 * Guard to make sure we have single initialization of forRoot
 * @type {InjectionToken<AchooModalDialogModule>}
 */
export const MODAL_DIALOG_FORROOT_GUARD = new InjectionToken<AchooModalDialogModule>('MODAL_DIALOG_FORROOT_GUARD');

@NgModule({
    imports: [CommonModule],
    declarations: [AchooModalDialogComponent, AchooSimpleModalComponent],
    entryComponents: [AchooModalDialogComponent, AchooSimpleModalComponent],
    exports: [AchooModalDialogComponent, AchooSimpleModalComponent],
    providers: [ModalDialogService]
})
export class AchooModalDialogModule {

    static forRoot(): ModuleWithProviders {
        return {
            ngModule: AchooModalDialogModule,
            providers: [
                {
                    provide: MODAL_DIALOG_FORROOT_GUARD,
                    useFactory: provideForRootGuard,
                    deps: [[AchooModalDialogModule, new Optional(), new SkipSelf()]]
                },
                AchooModalDialogInstanceService
            ]
        };
    }
}

/**
 * @param dialogModule
 * @returns {string}
 */
export function provideForRootGuard(dialogModule: AchooModalDialogModule): string {
    if (dialogModule) {
        throw new Error(
            `ModalDialogModule.forRoot() called twice.`);
    }
    return 'guarded';
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-modal-dialog/achoo-modal-dialog.module.ts